import styled from 'styled-components';

import { Button } from '@dreryk/react-components';

export const StyledConfidentialityRequestsButton = styled(Button)`
   position: relative;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   width: 24px;
   height: 24px;
   padding: 0;
   border: none;
   border-radius: 50%;
   background: transparent;
   overflow: visible;
   line-height: 0;
   color: ${(props) => props.theme.success};

   svg path {
      fill: currentColor;
   }

   &:not(:disabled):hover {
      background: transparent;
      border: none;
      color: ${(props) => props.theme.successDark};
   }
`;
StyledConfidentialityRequestsButton.displayName = 'StyledConfidentialityRequestsButton';
